import React, { useState } from "react";
import "./TopSelling.css";
import { TiTick } from "react-icons/ti";
import logo from "../../Assets/newAsset/clearFooter.svg";

import samBg from "../../Assets/newAsset/TopSelling/sam.webp";
import { LpFooter } from "../Corporate";
import { WhyChooseUs } from "./Newlp";
import { useHistory, useParams, useLocation } from "react-router-dom";
// import { useLocation,  } from "react-router";
import { Modal } from "react-responsive-modal";
import LpForm from "../LandingPages/Component/LpForm";
import { Link } from "react-router-dom";
import { Scroll } from "../../components/Scroll function/scroll";

export const TopsellingDiv = ({ title, footerTel,focus }) => {
  const [open, setOpen] = useState(false);
  const [reset, setreset] = useState(false);
  const history = useHistory();
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  const redirect = (param) => {
    console.log("this is slug", param);

    if (location.pathname.includes("/lp2/")) {
      setreset(true);
      focus.current.focus()
      // history.push({
      //   pathname: `/lp2/${param}`,
      // });
    } else if (location.pathname.includes("/lp6/")) {
      setreset(true);
      focus.current.focus()
      // history.push({
      //   pathname: `/lp6/${param}`,
      // });
    } else if (location.pathname.includes("/lp3/")) {
      setreset(true);
      history.push({
        pathname: `/lp3/${param}`,
      });
    }
    else if (location.pathname.includes("/lp2-taboola/")) {
      setreset(true);
      history.push({
        pathname: `/lp2-taboola/${param}`,
      });
      
    }

    Scroll();

    //console.log("pathname" ,location.pathname)
  };

  // const params = useParams();
  const location = useLocation();

  const Tests = [
    {
      name: "Smart Plus Full Body Checkup",
      testParam: 83,
      mrp: 2499,
      offerprice: 999,
      slug: "smart-plus-full-body-checkup",
    },
    {
      name: "Advance Full Body Checkup",
      testParam: 88,
      mrp: 4299,
      offerprice: 1349,
      slug: "advance-full-body-checkup",
    },
    {
      name: "Advance Plus Full Body Checkup",
      testParam: 92,
      mrp: 5999,
      offerprice: 1999,
      slug: "advance-plus-full-body-checkup",
    },
    {
      name: "Liver Function Test (LFT)",
      testParam: 1,
      mrp: 800,
      offerprice: 400,
      slug: "liver-function-test",
    },
    {
      name: "Healthy Heart Package",
      testParam: 56,
      mrp: 2499,
      offerprice: 1099,
      slug: "healthy-heart-package",
    },
    {
      name: "Kidney Function Test (KFT)",
      testParam: 10,
      mrp: 1560,
      offerprice: 399,
      slug: "kidney-function-test",
    },
  ];

  return (
    <div className="topSelling_product">
      <div className="content_div">
        <h2 className="allHeadings">{title}</h2>
        <div className="selling_cards">
          {Tests.map((values, index) => {
            return (
              <div className="topCards" key={index}>
                <h4 className="topCardsh4">
                  {/* <a target="_blank" href="https://redcliffelabs.com/lp/smart-full-body-checkup"> */}
                  {values.name}
                  {/* </a> */}
                </h4>
                <div className="cardContentSelling">
                  <p className="parameters">
                    {" "}
                    <TiTick />
                    Total no.of {values.testParam > 1 ? "Tests" : "Test"}  - {values.testParam}
                  </p>
                  <span
                    className=" spanMrp"
                    style={{ textDecoration: "line-through" }}
                  >
                    MRP: ₹ {values.mrp}
                  </span>
                  <div className="price">
                    <span className="spanPrice">Starts from <span style={{color :"#31CCB0"}}>₹{values.offerprice}</span></span>
                  </div>

                  <button
                    className="topCardsButon"
                    onClick={() => redirect(values.slug)}
                  >
                    Book Now
                  </button>
                </div>
              </div>
            );
          })}

          {/* <div className="topCards">
            <h4>Smart Full Body Check-up</h4>
            <p className="parameters">Total no.of Tests - 73</p>
            <div className="price">
              <span className=" spanMrp" style={{ textDecoration: "line-through" }}>MRP: ₹1740</span>
              <span className="spanPrice">₹ 650</span>
            </div>
            <button>Book Now</button>
          </div> */}
        </div>
      </div>
    </div>
  );
};
const TopSellingForm = () => {
  return (
    <form className="topSelling_form">
      <div className="contentForm">
        <h2 className="blueHeading">Book Your Test</h2>
        <p className="topSellingText">
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
        </p>

        <div className="formInputs">
          <div className="topInputs">
            <input placeholder="Enter Name" type="text" />
            <p className="topSelling_Error">errorHere</p>
          </div>
          <div className="topInputs">
            <input placeholder="Enter Phone Number" type="number" />
            <p className="topSelling_Error">errorHere</p>
          </div>
          <div className="topInputs">
            <input placeholder="Enter City" type="text" />
            <p className="topSelling_Error">errorHere</p>
          </div>
          <div className="topInputs">
            <input placeholder="Select Test" type="text" />
            <p className="topSelling_Error">errorHere</p>
          </div>
        </div>
        <div className="inputSubmit">
          <button type="submit">SUBMIT</button>
        </div>
      </div>
    </form>
  );
};
function TopSelling() {
  return (
    <>
      <div className="TopSelling">
        <div className="topSelling__COntent">
          <div className="Topselling_leftSide">
            <div className="logoImg">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
                alt={logo}
                className="img_fluid"
              />
            </div>
            <div className="Sambanner">
              <img src={samBg} alt={samBg} className="img_fluid" />
            </div>
          </div>
          <div className="TopSelling_rightSide">
            <form className="topSelling_form">
              <div className="contentForm">
                <h2 className="blueHeading">Book Your Test</h2>
                <p className="topSellingText">
                  Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
                  diam
                </p>

                <div className="formInputs">
                  <div className="topInputs">
                    <input placeholder="Enter Name" type="text" />
                    <p className="topSelling_Error">errorHere</p>
                  </div>
                  <div className="topInputs">
                    <input placeholder="Enter Phone Number" type="number" />
                    <p className="topSelling_Error">errorHere</p>
                  </div>
                  <div className="topInputs">
                    <input placeholder="Enter City" type="text" />
                    <p className="topSelling_Error">errorHere</p>
                  </div>
                  <div className="topInputs">
                    <input placeholder="Select Test" type="text" />
                    <p className="topSelling_Error">errorHere</p>
                  </div>
                </div>
                <div className="inputSubmit">
                  <button type="submit">SUBMIT</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/**TOP SELLING */}
      <div className="mobileTopSelling">
        <TopSellingForm />
      </div>
      {/**Top selling section */}
      <TopsellingDiv />
      <WhyChooseUs />
      <LpFooter />
    </>
  );
}

export default {
  component: TopSelling,
};
